module.exports = __webpack_public_path__ + "static/media/logout-avatar-kn.e1df52e2.svg";